<!-- =========================================================================================
    File Name: Chat.vue
    Description: Chat Application - Stay connected
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <vs-sidebar class="items-no-padding" parent="#chat-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isChatSidebarActive" id="chat-list-sidebar">

            <!-- USER PROFILE SIDEBAR -->
            <user-profile :active="activeProfileSidebar" :userId="userProfileId" class="user-profile-container" :isLoggedInUser="isLoggedInUserProfileView" @closeProfileSidebar="closeProfileSidebar"></user-profile>

            <div class="chat__profile-search flex p-4">
                <div class="relative inline-flex">
                    <vs-avatar v-if="arr.profilephoto || arr.photo" class="m-0 border-2 border-solid border-white" :src="activeUser.profilephoto || activeUser.photo" size="40px" @click="showProfileSidebar((activeUser), true)" />
                    <div class="h-3 w-3 border-white border border-solid rounded-full absolute right-0 bottom-0" :class="'bg-' + getStatusColor(true)"></div>
                </div>
                <vs-input icon-no-border icon="icon-search" icon-pack="feather" class="w-full mx-5 input-rounded-full" placeholder="Search or start a new chat" v-model="searchQuery"/>

                <feather-icon class="md:inline-flex lg:hidden -ml-3 cursor-pointer" icon="XIcon" @click="toggleChatSidebar(false)" />
            </div>

            <vs-divider class="d-theme-border-grey-light m-0" />
            <VuePerfectScrollbar class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl">
                <!-- CONTACTS LIST -->
                <div class="chat__contacts" v-if="id ||  $acl.get[0] ==='editor' || idy">
                    <h3 class="text-primary mb-5 px-4">New Conversation</h3>
                    <ul class="chat__contacts bordered-items">
                        <li class="cursor-pointer"  v-for="contact in obj3" :key="contact.uid" @click="updateActiveChatUser(contact)">
                            <chat-contact :contact="contact"></chat-contact>
                        </li>
                    </ul>
                </div>
                <!-- ACTIVE CHATS LIST -->
                <div class="chat__chats-list mb-8">
                    <h3 class="text-primary mb-5 px-4">Conversations</h3>
                    <ul class="chat__active-chats bordered-items">
                        <li class="cursor-pointer" v-for="(contact) in obj2" :key="contact.uid" @click="updateActiveChatUser(contact)">
                            <chat-contact showLastMsg :contact="contact" :lastMessaged="chatLastMessaged(contact.uid).time"  :isActiveChatUser="isActiveChatUser(contact.uid)"></chat-contact>
                        </li>
                    </ul>
                </div>


                
            </VuePerfectScrollbar>
        </vs-sidebar>

        <!-- RIGHT COLUMN -->
        <div class="chat__bg no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0" :class="{'sidebar-spacer--wide': clickNotClose, 'flex items-center justify-center': activeChatUser === null}">
            <template v-if="activeChatUser">
                <div class="chat__navbar">
                    <chat-navbar :isSidebarCollapsed="!clickNotClose" :user-id="activeChatUser" :isPinnedProp="isChatPinned" @openContactsSidebar="toggleChatSidebar(true)" @showProfileSidebar="showProfileSidebar" @toggleIsChatPinned="toggleIsChatPinned"></chat-navbar>
                </div>
                <VuePerfectScrollbar class="chat-content-scroll-area border border-solid d-theme-border-grey-light" :settings="settings" ref="chatLogPS" :key="$vs.rtl">
                    <div class="chat__log" ref="chatLog">
                        <chat-log :userId="activeChatUser" :currentUser="arr" v-if="activeChatUser" :collegecode="studentcode"></chat-log>
                    </div>
                </VuePerfectScrollbar>
                <div class="chat__input flex p-4 bg-white">
                    <vs-input class="flex-1" placeholder="Type Your Message" v-show="!attachment" v-model="typedMessage" @keyup.enter="sendMsg(activeChatUser.role, activeChatUser.uid)" />
                    {{attachment}}
                    <vx-tooltip text="Attach File">
                    <vs-button class="ml-1 mt-1" color="primary" type="line" icon-pack="feather" icon="icon-link" @click.prevent="popupActive=true"> </vs-button></vx-tooltip>
                    <vs-popup class="holamundo" title="Attach File" :active.sync="popupActive" background-color="rgba(255,255,255,.6)">
                                      
                                          
                                            <vs-upload  text="Attachment"  name="10marksheet" action="#" @change="fileinput($event)" :show-upload-button="button" :show-remove-button="button" limit=1  >
                                           
                                            </vs-upload>
                                       
                                 </vs-popup>
                    <vs-button class="bg-primary-gradient ml-4" type="filled" @click="sendMsg(activeChatUser.role, activeChatUser.uid)">Send</vs-button>
                </div>
            </template>
            <template v-else>
                <div class="flex flex-col items-center">
                    <feather-icon icon="MessageSquareIcon" class="mb-4 bg-white p-8 shadow-md rounded-full" svgClasses="w-16 h-16"></feather-icon>
                    <h4 class=" py-2 px-4 bg-white shadow-md rounded-full cursor-pointer" @click.stop="toggleChatSidebar(true)">Start Conversation</h4>
                    <span class=" py-1 px-2  text-center text-success flex" >  <vs-icon icon="lock" class="mr-1 "  color="success"></vs-icon><h6 class=" text-success font-semibold">Conversations and Meetings are end-to-end encrypted.</h6> </span>
                </div>
            </template>
            
        </div>
    </div>
</template>

<script>
import ChatContact         from "./ChatContact.vue"
import ChatLog             from './ChatLog.vue'
import ChatNavbar          from './ChatNavbar.vue'
import UserProfile         from "./UserProfile.vue"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleChat          from '@/store/chat/moduleChat.js'
import * as firebase from 'firebase/app'
import "firebase/auth"
import "firebase/firestore"
import "firebase/database"
import "firebase/storage"
import "firebase/messaging"
export default {
  data() {
    return {
      active               : true,
      filechanged          :false,
      isHidden             : false,
      searchContact        : "",
      activeProfileSidebar : false,
      activeChatUser       : null,
      userProfileId        : {},
      typedMessage         : "",
      isChatPinned         : false,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.70,
      },
      clickNotClose        : true,
      isChatSidebarActive  : true,
      isLoggedInUserProfileView: false,
      arr:{},
      obj2:[ {
                            uid : 'flairboat-chat-admin',
                            username : 'Flairboat Support',
                            profilephoto:'https://firebasestorage.googleapis.com/v0/b/flairboat-9a97e.appspot.com/o/Colleges%2FLogo%2FBsR8lRTbenTjHlUIZvzxxrWe1E73logo2.png?alt=media&token=10c1735c-8bd1-4266-8e8b-4a91ae619c0c',
                            status :'online',
                            role:'support'
                        }],
      obj3:[],
      id:"",
      files:"",
      attachment:"",
      button:false,
      popupActive:false,
      studentcode:'',
      collegecode:'',
      TRPcode:'',
      TRPscode:''
    }
  },
  watch: {
    windowWidth() {
      this.setSidebarWidth()
    },
    id(){
      this.contacts
      this.chatContacts
    },
    obj2(){
      this.chatContacts
    },
    obj3(){
      this.contacts
    },
    studentcode(){
      this.chatContacts
      this.contacts
    },
    collegecode(){
      this.chatContacts
      this.contacts
    }
    
  },
  computed: {
    chatLastMessaged() {
     // return (userId) => this.$store.getters['chat/chatLastMessaged'](userId)
      return (userId) => {if(userId) return true}
    },
    chatUnseenMessages() {
      return (userId) => {
        return 5
      }
    },
    activeUser() {
      return this.arr
    },
    getStatusColor() {
      return (isActiveUser) => {
        const userStatus = this.getUserStatus(isActiveUser)

        if (userStatus == "online") {
          return "success"
        } else if (userStatus == "do not disturb") {
          return "danger"
        } else if (userStatus == "away") {
          return "warning"
        } else {
          return "grey"
        }
      }
    },
    chatContacts() {
      //return this.$store.getters['chat/chatContacts']
       const user=firebase.auth().currentUser
      const thisIns = this
                              // console.log(thisIns.obj2)

          if(thisIns.$acl.get[0]==='post' || thisIns.$acl.get[0]==='hr')
          {
             var starCountRef = firebase.database().ref("Recruiter").child(user.uid)
            starCountRef.on('value',snapshot=>{
              snapshot.forEach(doc=>{
                    var key = doc.key
                       
                            let Ref = firebase.firestore().collection("StudentID").doc(key).get().then(doc=>{
                                        if(doc.exists){
                                        ////console.log(doc.data())

                                        var obj = {
                                uid : doc.id,
                              username : doc.data().FullName,
                              profilephoto:doc.data().profilephoto,
                            collegeName:doc.data().CollegeName,
                            course:doc.data().courseName,
                            tokens:[],
                            //isActiveChatUser : true,
                            status :'offline',
                            role:'student'
                      
                        }
                       
                      
                      thisIns.obj2.push(obj) 
                      //////console.log(thisIns.obj2)
                      //return thisIns.obj2
                                        }
                                      })
                            
                          
                })
              })
              var tpo =firebase.database().ref(user.uid)
              tpo.once('value',snapshot=>{
                snapshot.forEach(doc=>{
                  var key = doc.key
                  //console.log(key)
                 firebase.firestore().collection("TPOid").doc(key).get().then( docs => {
                       if(docs.exists){
                         //console.log(docs.data())
                          var obj = {
                                uid : docs.id,
                              username : docs.data().FullName,
                              profilephoto:docs.data().photo,
                            collegeName:docs.data().CollegeName,
                            course:docs.data().courseName,
                            //isActiveChatUser : true,
                            status :'offline',
                            role:'tpo'
                      
                        }
                       // console.log(obj)
                      thisIns.obj2.push(obj) 
                       }
                       else {
                          firebase.firestore().collection("TRPid").doc(key).get().then( docs => {
                       if(docs.exists){
                         //console.log(docs.data())
                          var obj = {
                                uid : docs.id,
                              username : docs.data().FullName,
                              profilephoto:docs.data().photo,
                            collegeName:docs.data().TrainingCompany,
                            //isActiveChatUser : true,
                            status :'offline',
                            role:'trp'
                      
                        }
                       // console.log(obj)
                      thisIns.obj2.push(obj) 
                       }
                     })
                       }
                     })
                   
                })
              })
            }
            else if(thisIns.$acl.get[0]==='admin')
          {
            var obj = {}
             var starRef = firebase.database().ref("TPO").child(user.uid)
            starRef.on('value',snapshot=>{
              snapshot.forEach(doc=>{
                    var key = doc.key
                       if(thisIns.studentcode){
                            let Ref = firebase.firestore().collection('StudentID').doc(key).get().then(doc=>{
                                        if(doc.exists){
                                        ////console.log(doc.data())
                                        obj = {
                                            uid : doc.id,
                                          username : doc.data().FullName,
                                          profilephoto:doc.data().photo,
                                          collegeName:doc.data().CollegeName,
                                        //isActiveChatUser : true,
                                          status :'offline',
                                          role:'student'
                                         }
                                      thisIns.obj2.push(obj) 
                                      //console.log(thisIns.obj2)
                                      //return thisIns.obj2
                                        }
                                      })
                       }
                            })
                          })
                var CountRef = firebase.database().ref("TPO+Recruiter/"+user.uid)
                CountRef.once('value',snapshot=>{
                  snapshot.forEach(doc=>{
                    var keys = doc.key
                    // console.log(keys)
                    let Ref= firebase.firestore().collection('RecruiterId').doc(keys).get().then(docs=>{
                      if(docs.exists){
                        ////console.log(doc.data())
                         obj={
                          uid:docs.id,
                          username:docs.data().ContactName,
                          profilephoto:docs.data().profilephoto,
                        //isActiveChatUser : true,
                          status :'offline',
                          role:'recruiter'

                        }
                        thisIns.obj2.push(obj) 
                        //return thisIns.obj2
                        

                      }
                    })
                  })
                })
                                      // console.log(thisIns.obj2)

            }

             else if(thisIns.$acl.get[0]==='trp')
          {
            var obj = {}
             var starRef = firebase.database().ref("TRP").child(user.uid)
            starRef.on('value',snapshot=>{
              snapshot.forEach(doc=>{
                    var key = doc.key
                       if(thisIns.TRPscode){
                            let Ref = firebase.firestore().collection('StudentID').doc(key).get().then(doc=>{
                                        if(doc.exists){
                                        ////console.log(doc.data())
                                        obj = {
                                            uid : doc.id,
                                          username : doc.data().FullName,
                                          profilephoto:doc.data().profilephoto,
                                          collegeName:doc.data().CollegeName,
                                        //isActiveChatUser : true,
                                          status :'offline',
                                          role:'student'
                                         }
                                      thisIns.obj2.push(obj) 
                                      //console.log(thisIns.obj2)
                                      //return thisIns.obj2
                                        }
                                      })
                       }
                            })
                          })
                var CountRef = firebase.database().ref("TRP+Recruiter/"+user.uid)
                CountRef.once('value',snapshot=>{
                  snapshot.forEach(doc=>{
                    var keys = doc.key
                    // console.log(keys)
                    let Ref= firebase.firestore().collection('RecruiterId').doc(keys).get().then(docs=>{
                      if(docs.exists){
                        ////console.log(doc.data())
                         obj={
                          uid:docs.id,
                          username:docs.data().ContactName,
                          profilephoto:docs.data().profilephoto,
                        //isActiveChatUser : true,
                          status :'offline',
                          role:'recruiter'

                        }
                        thisIns.obj2.push(obj) 
                        //return thisIns.obj2
                        

                      }
                    })
                  })
                })
                                      // console.log(thisIns.obj2)

            }
    else if(thisIns.$acl.get[0]==='editor'){
       var starCountRef = firebase.database().ref(user.uid)
       starCountRef.once('value',snapshot=>{
         snapshot.forEach(doc=>{
           var key = doc.key
           let Ref= firebase.firestore().collection('RecruiterId').doc(key).get().then(doc=>{
             if(doc.exists){
               ////console.log(doc.data())
               var obj={
                 uid:doc.id,
                 username:doc.data().ContactName,
                 profilephoto:doc.data().profilephoto,
              //isActiveChatUser : true,
                status :'offline',
                role:'recruiter'

               }
               thisIns.obj2.push(obj) 
               //console.log(thisIns.obj2)
              
               

             }
             else{
               //console.log(thisIns.collegecode)
               let Refs = firebase.firestore().collection("TPOid")
               Refs.doc(key).get().then(doc =>{
                 if(doc.exists){
               ////console.log(doc.data())
               var obj={
                 uid:doc.id,
                 username:doc.data().FullName,
                 profilephoto:doc.data().photo,
              //isActiveChatUser : true,
                status :'offline',
                role:'tpo'

               }
               thisIns.obj2.push(obj) 
               //console.log(thisIns.obj2)
                //return thisIns.obj2
               

             }
             else{
               firebase.firestore().collection('HRid').doc(key).get().then(doc=>{
             if(doc.exists){
               ////console.log(doc.data())
               var obj={
                 uid:doc.id,
                 username:doc.data().ContactName,
                 profilephoto:doc.data().profilephoto,
              //isActiveChatUser : true,
                status :'offline',
                role:'recruiter'

               }
               thisIns.obj2.push(obj) 
               //console.log(thisIns.obj2)
              }
              else {
                firebase.firestore().collection("TRPid").doc(key).get().then(doc =>{
                 if(doc.exists){
               ////console.log(doc.data())
               var obj={
                 uid:doc.id,
                 username:doc.data().FullName,
                 profilephoto:doc.data().photo,
              //isActiveChatUser : true,
                status :'offline',
                role:'trp'

               }
               thisIns.obj2.push(obj) 
               //console.log(thisIns.obj2)
                //return thisIns.obj2
               

             }
                })
              }
               })
             }
             
               })
             }
           })
         })
       })

    }
    },
    contacts() {
      //return this.$store.getters['chat/contacts']
       const user=firebase.auth().currentUser
      const thisIns = this
       if(this.$acl.get[0]==='admin'){
        if(thisIns.id){
          firebase.firestore().collection("StudentID").doc(thisIns.id).get().then( doc => {
              if(doc.exists){
                                        //////console.log(doc.data())
                             var obj = {
                            uid : doc.id,
                            username : doc.data().FullName,
                            profilephoto:doc.data().profilephoto,
                            collegeName:doc.data().CollegeName,
                            course:doc.data().courseName,
                            status :'offline',
                            role:'student'
                        }
                      thisIns.obj3.push(obj) 
                      ////console.log(thisIns.obj3)
                      return thisIns.obj3
                                        }
          })
        } 
        if(thisIns.idy){
          //console.log(thisIns.idy)
          let Refs = firebase.firestore().collection("RecruiterId").doc(thisIns.idy)
          Refs.get().then( doc => {
            if(doc.exists){
              // console.log(doc.data())
              var obj = {
                            uid : doc.id,
                            username : doc.data().ContactName,
                            profilephoto:doc.data().profilephoto,
                            companyName:doc.data().CompanyName,
                            designation:doc.data().Designation,
                            status :'offline',
                            role:'recruiter'
                        }
                        thisIns.obj3.push(obj) 
                      //console.log(thisIns.obj3)
                      return thisIns.obj3
            }
          })
        }
       }
 if(this.$acl.get[0]==='trp'){
        if(thisIns.id){
          firebase.firestore().collection("StudentID").doc(thisIns.id).get().then( doc => {
              if(doc.exists){
                                        //////console.log(doc.data())
                             var obj = {
                            uid : doc.id,
                            username : doc.data().FullName,
                            profilephoto:doc.data().profilephoto,
                            collegeName:doc.data().CollegeName,
                            course:doc.data().courseName,
                            status :'offline',
                            role:'student'
                        }
                      thisIns.obj3.push(obj) 
                      ////console.log(thisIns.obj3)
                      return thisIns.obj3
                                        }
          })
        } 
        if(thisIns.idy){
          //console.log(thisIns.idy)
          let Refs = firebase.firestore().collection("RecruiterId").doc(thisIns.idy)
          Refs.get().then( doc => {
            if(doc.exists){
              // console.log(doc.data())
              var obj = {
                            uid : doc.id,
                            username : doc.data().ContactName,
                            profilephoto:doc.data().profilephoto,
                            companyName:doc.data().CompanyName,
                            designation:doc.data().Designation,
                            status :'offline',
                            role:'recruiter'
                        }
                        thisIns.obj3.push(obj) 
                      //console.log(thisIns.obj3)
                      return thisIns.obj3
            }
          })
        }
       }

          if(this.$acl.get[0]==='post')
          {
           
                          if(thisIns.id){
                         ////console.log(thisIns.id)
                            let Ref = firebase.firestore().collection('StudentID').doc(thisIns.id).get().then(doc=>{
                                        if(doc.exists){
                                        //////console.log(doc.data())
                                        var obj = {
                                uid : doc.id,
                              username : doc.data().FullName,
                              profilephoto:doc.data().profilephoto,
                           
                             collegeName:doc.data().CollegeName,
                            course:doc.data().courseName,
                            status :'offline',
                            role:'student'
                      
                      
                        }

                      
                      thisIns.obj3.push(obj) 
                      ////console.log(thisIns.obj3)
                      return thisIns.obj3
                                        }
                                      })
                            
                          }
        
    }
    else if(this.$acl.get[0]==='hr')
          {
           
                          if(thisIns.id){
                         ////console.log(thisIns.id)
                            let Ref = firebase.firestore().collection('StudentID').doc(thisIns.id).get().then(doc=>{
                                        if(doc.exists){
                                        //////console.log(doc.data())
                                        var obj = {
                                uid : doc.id,
                              username : doc.data().FullName,
                              profilephoto:doc.data().profilephoto,
                           
                             collegeName:doc.data().CollegeName,
                            course:doc.data().courseName,
                            status :'offline',
                            role:'student'
                      
                      
                        }

                      
                      thisIns.obj3.push(obj) 
                      ////console.log(thisIns.obj3)
                      return thisIns.obj3
                                        }
                                      })
                            
                          }
        
    }
    else if(this.$acl.get[0]==='editor'){
        //if(thisIns.id){
       firebase.firestore().collection("TPOid").where('StudentCode','==',this.studentcode).orderBy('timestamp','asc').onSnapshot(function(snapshot){
      snapshot.forEach(doc =>{
              if(doc.exists){
                                        //////console.log(doc.data())
                             var obj = {
                            uid : doc.id,
                            username : doc.data().FullName,
                            profilephoto:doc.data().photo,
                            collegeName:doc.data().CollegeName,
                            status :'offline',
                            role:'tpo'
                        }
                      thisIns.obj3.push(obj) 
                      //console.log(thisIns.obj3)
                      return thisIns.obj3
                                        }

            else {
               firebase.firestore().collection("TRPid").where('TRPscode','==',this.TRPscode).orderBy('timestamp','asc').onSnapshot(function(snapshot){
      snapshot.forEach(doc =>{
              if(doc.exists){
                                        //////console.log(doc.data())
                             var obj = {
                            uid : doc.id,
                            username : doc.data().FullName,
                            profilephoto:doc.data().photo,
                            collegeName:doc.data().CollegeName,
                            status :'offline',
                            role:'tpo'
                        }
                      thisIns.obj3.push(obj) 
                      //console.log(thisIns.obj3)
                      return thisIns.obj3
                                        }
          })
               })
            }
          })
          })
        //} 
       }
   
    },
    searchQuery: {
      get() {
        return this.$store.state.chat.chatSearchQuery
      },
      set(val) {
        this.$store.dispatch('chat/setChatSearchQuery', val)
      }
    },
   
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },
  methods: {
     isActiveChatUser(userId) {
      //  console.log(this.activeChatUser)
      //  console.log(userId)
      return (this.activeChatUser) && (userId == this.activeChatUser.uid)
    },
    fileinput($event){
      console.log(event)
      var file =event.target.files[0]
          var user= firebase.auth().currentUser
          if(file){
           this.attachment = file.name;
           console.log(this.attachment)
           var storageRef = firebase.storage().ref('chat/msg_doc'+user.uid+file.name)
  //Upload file
                  const thisIns =this
                    storageRef.put(file).then(function(result){
                        storageRef.getDownloadURL().then(function(url){
                     
                     var img=url;
         
             thisIns.files = img
             //console.log(thisIns.files)
             
           //  console.log("file saved")
                        })
                })
             thisIns.popupActive = false   
          }
          else{
            this.attachment=''
            this.files =''
          }
    },
    browse(){
      this.filechanged = true
    },
    getUserStatus(isActiveUser) {
      // return "active"
      return (isActiveUser) ? this.$store.state.AppActiveUser.status : this.contacts[this.activeChatUser].status
    },
    closeProfileSidebar(value) {
      this.activeProfileSidebar = value
    },
    updateActiveChatUser(contactId) {
      // console.log(contactId)
      this.activeChatUser = contactId
      
      var obj ={};
      const user = firebase.auth().currentUser
      if(this.$acl.get[0]==='post'){
        if(contactId.role == 'student'){
       const messageRef = firebase.database().ref(contactId.uid).child(user.uid);
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                        
                        obj=data.val()
                        if(obj.msg){
                         if(obj.msg.role==='editor'){
                            
                             if(!obj.msg.isSeen){
                              messageRef.child(data.key).child('msg').child('isSeen').set(true)
                             }
                         }
                        }
                         
                      })
        }
        if(contactId.role == 'tpo'){
        const Ref = firebase.database().ref(user.uid).child(contactId.uid)
        Ref.orderByChild('timestamp').on('child_added' ,data => {
                        
                        obj=data.val()
                         if(obj.msg.role==='admin'){
                            
                             if(!obj.msg.isSeen){
                              Ref.child(data.key).child('msg').child('isSeen').set(true)
                             }
                         }
                         
                      })
        }

      }
      
      else if(this.$acl.get[0]==='hr'){
        if(contactId.role == 'student'){
       const messageRef = firebase.database().ref(contactId.uid).child(user.uid);
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                        
                        obj=data.val()
                        if(obj.msg){
                         if(obj.msg.role==='editor'){
                            
                             if(!obj.msg.isSeen){
                              messageRef.child(data.key).child('msg').child('isSeen').set(true)
                             }
                         }
                        }
                         
                      })
        }
        if(contactId.role == 'tpo'){
        const Ref = firebase.database().ref(user.uid).child(contactId.uid)
        Ref.orderByChild('timestamp').on('child_added' ,data => {
                        
                        obj=data.val()
                         if(obj.msg.role==='admin'){
                            
                             if(!obj.msg.isSeen){
                              Ref.child(data.key).child('msg').child('isSeen').set(true)
                             }
                         }
                         
                      })
        }

      }
      else if(this.$acl.get[0]==='admin'){
        if(contactId.uid === 'flairboat-chat-admin'){
                  // console.log( this.activeChatUser )

        }
        else{
        if(contactId.role == 'student'){
       const messageRef = firebase.database().ref(contactId.uid).child(user.uid);
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                        
                        obj=data.val()
                         if(obj.msg.role==='editor'){
                            
                             if(!obj.msg.isSeen){
                              messageRef.child(data.key).child('msg').child('isSeen').set(true)
                             }
                         }
                         
                      })
        }
        else if (contactId.role = 'recruiter'){
          // console.log('here role')
         var Ref=firebase.database().ref(contactId.uid).child(user.uid) 
          Ref.orderByChild('timestamp').on('child_added' ,data => {
                        // console.log(data.val())
                        obj=data.val()
                         if(obj.msg.role==='post'){
                            
                             if(!obj.msg.isSeen){
                              Ref.child(data.key).child('msg').child('isSeen').set(true)
                             }
                         }
                         
                      })
        }
      }
      }
      else if(this.$acl.get[0]==='editor'){
        const messageRef = firebase.database().ref(user.uid).child(contactId.uid);
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                        
                        obj=data.val()
                         if(obj.msg.role==='post'){
                             if(!obj.msg.isSeen){
                              messageRef.child(data.key).child('msg').child('isSeen').set(true)
                             }
                             }
                        else if(obj.msg.role==='admin'){
                             if(!obj.msg.isSeen){
                              messageRef.child(data.key).child('msg').child('isSeen').set(true)
                             }
                             }
                         
                         
                      })
      }
      if(contactId) this.isChatPinned = true;
      else this.isChatPinned = false
      this.toggleChatSidebar()
      this.typedMessage = ''
    },
    showProfileSidebar(userId, openOnLeft = false) {
      this.userProfileId = userId
      this.isLoggedInUserProfileView = openOnLeft
      this.activeProfileSidebar = !this.activeProfileSidebar
    },
    sendMsg(role,uid) {
     // console.log(role)
       if (!this.typedMessage ) {
        if(!this.files) return 
      } 
      
      const u= firebase.auth().currentUser
      // console.log(uid)
      if(uid === 'flairboat-chat-admin'){
        
       const thisIns = this
       var role = thisIns.$acl.get[0]
       var Rec=firebase.database().ref('flairboat-chat-admin/'+u.uid).update({
                  'id':  u.uid,
                  'role': role,
                  'username': thisIns.arr.username,
                  'email': thisIns.arr.email,
                  'profilephoto' : thisIns.arr.photo
              }, function(error) {
            if (error) {
              console.log(error)
            } else {
              // console.log("Saved")
              // console.log(thisIns.typedMessage)
              var Ref =firebase.database().ref(uid).child(u.uid).push()
        Ref.set({
            isPinned: thisIns.isChatPinned,
        msg: {
          'role'        : role,
          // 'username'    :u.username,
          'textContent' : thisIns.typedMessage,
          'time'        : String(new Date()),
          'isSent'      : true,
          'isSeen'      : false,
          'attachment'  :thisIns.files,
          'notify'      :'support'
        }
        }, function(error) {
            if (error) {
              console.log(error)
            } else {
              console.log("Saved")
            }
        }).then(()=>{
           thisIns.typedMessage = ''
      thisIns.files =''
      thisIns.attachment=''
      thisIns.$refs.chatLogPS.$el.scrollTop = thisIns.$refs.chatLog.scrollHeight
        })
            }
              })
        // var Ref =firebase.database().ref(uid).child(u.uid).push()
        // Ref.set({
        //     isPinned: this.isChatPinned,
        // msg: {
        //   'role'        : role,
        //   // 'username'    :u.username,
        //   'textContent' : this.typedMessage,
        //   'time'        : String(new Date()),
        //   'isSent'      : true,
        //   'isSeen'      : false,
        //   'attachment'  :this.files
        // }
        // }, function(error) {
        //     if (error) {
        //       console.log(error)
        //     } else {
        //       console.log("Saved")
        //       var Rec=firebase.database().ref('flairboat-chat-admin/'+u.uid).set({
        //           'id':  u.uid,
        //           'role': role,
        //           'username': thisIns.arr.username,
        //           'email': thisIns.arr.email,
        //           'profilephoto' : thisIns.arr.photo
        //       },{merge:true})                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
        //     }
        // })
      }
      else{
          var id=this.activeChatUser.uid
          if(this.$acl.get[0]==='admin'){
            //console.log(role)
            if(role == 'student'){
        var Ref=firebase.database().ref(this.activeChatUser.uid).child(u.uid).push()
        Ref.set({
           isPinned: this.isChatPinned,
        msg: {
          'role'        : 'admin',
          'textContent' : this.typedMessage,
          'time'        : String(new Date()),
          'isSent'      : true,
          'isSeen'      : false,
          'attachment'  :this.files,
          'notify'      :'chattpo'
        }
        }, function(error) {
            if (error) {
              //console.log(error)
            } else {
              //console.log("Saved")
              
              var Rec=firebase.database().ref('TPO/'+u.uid).child(id).set({
                  'id':id
              })
              
              
            }
              })
            }
            else if(role == 'recruiter'){
              var Ref=firebase.database().ref(this.activeChatUser.uid).child(u.uid).push()
        Ref.set({
           isPinned: this.isChatPinned,
        msg: {
          'role'        : 'admin',
          'textContent' : this.typedMessage,
          'time'        : String(new Date()),
          'isSent'      : true,
          'isSeen'      : false,
          'attachment'  :this.files
        }
        }, function(error) {
            if (error) {
              //console.log(error)
            } else {
              //console.log("Saved")
              
              var Rec=firebase.database().ref('TPO+Recruiter/'+u.uid).child(id).set({
                  'id':id
              })
              
              
            }
              })
            }
          }
           if(this.$acl.get[0]==='trp'){
            //console.log(role)
            if(role == 'student'){
        var Ref=firebase.database().ref(this.activeChatUser.uid).child(u.uid).push()
        Ref.set({
           isPinned: this.isChatPinned,
        msg: {
          'role'        : 'trp',
          'textContent' : this.typedMessage,
          'time'        : String(new Date()),
          'isSent'      : true,
          'isSeen'      : false,
          'attachment'  :this.files,
          'notify'      :'chattrp'
        }
        }, function(error) {
            if (error) {
              //console.log(error)
            } else {
              //console.log("Saved")
              
              var Rec=firebase.database().ref('TRP/'+u.uid).child(id).set({
                  'id':id
              })
              
              
            }
              })
            }
            else if(role == 'recruiter'){
              console.log(this.activeChatUser)
              var Ref=firebase.database().ref(this.activeChatUser.uid).child(u.uid).push()
        Ref.set({
           isPinned: this.isChatPinned,
        msg: {
          'role'        : 'trp',
          'textContent' : this.typedMessage,
          'time'        : String(new Date()),
          'isSent'      : true,
          'isSeen'      : false,
          'attachment'  :this.files
        }
        }, function(error) {
            if (error) {
              //console.log(error)
            } else {
              //console.log("Saved")
              
              var Rec=firebase.database().ref('TRP+Recruiter/'+u.uid).child(id).set({
                  'id':id
              })
              
              
            }
              })
            }
          }
          if(this.$acl.get[0]==='post'){
                          console.log(this.activeChatUser)

            if(role == 'student'){
        var Ref=firebase.database().ref(this.activeChatUser.uid).child(u.uid).push()
        Ref.set({
           isPinned: this.isChatPinned,
        msg: {
          'role'        : 'post',
          'textContent' : this.typedMessage,
          'time'        : String(new Date()),
          'isSent'      : true,
          'isSeen'      : false,
          'attachment'  :this.files,
          'notify'        :'chatrecruiter' 
        }
        }, function(error) {
            if (error) {
              //console.log(error)
            } else {
             // console.log("Saved")
              
              var Rec=firebase.database().ref('Recruiter/'+u.uid).child(id).set({
                  'id':id
              })
              firebase.messaging().sendTo
              
              
            }
              })
            }
            if(role === 'tpo'){
              var Ref=firebase.database().ref(u.uid).child(this.activeChatUser.uid).push()
        Ref.set({
           isPinned: this.isChatPinned,
        msg: {
          'role'        : 'post',
          'textContent' : this.typedMessage,
          'time'        : String(new Date()),
          'isSent'      : true,
          'isSeen'      : false,
          'attachment'  :this.files
        }
        }, function(error) {
            if (error) {
              //console.log(error)
            } else {
              //console.log("Saved")
                
            }
              })
            }
            if(role === 'trp'){
              var Ref=firebase.database().ref(u.uid).child(this.activeChatUser.uid).push()
        Ref.set({
           isPinned: this.isChatPinned,
        msg: {
          'role'        : 'post',
          'textContent' : this.typedMessage,
          'time'        : String(new Date()),
          'isSent'      : true,
          'isSeen'      : false,
          'attachment'  :this.files
        }
        }, function(error) {
            if (error) {
              //console.log(error)
            } else {
              //console.log("Saved")
                
            }
              })
            }
          }
          
          else if(this.$acl.get[0]==='hr'){
            if(role == 'student'){
        var Ref=firebase.database().ref(this.activeChatUser.uid).child(u.uid).push()
        Ref.set({
           isPinned: this.isChatPinned,
        msg: {
          'role'        : 'post',
          'textContent' : this.typedMessage,
          'time'        : String(new Date()),
          'isSent'      : true,
          'isSeen'      : false,
          'attachment'  :this.files,
          'notify'      :'chathr'
        }

        }, function(error) {
            if (error) {
              //console.log(error)
            } else {
             // console.log("Saved")
              
              var Rec=firebase.database().ref('Recruiter/'+u.uid).child(id).set({
                  'id':id
              })
              
              
            }
              })
            }
            if(role === 'tpo'){
              var Ref=firebase.database().ref(u.uid).child(this.activeChatUser.uid).push()
        Ref.set({
           isPinned: this.isChatPinned,
        msg: {
          'role'        : 'post',
          'textContent' : this.typedMessage,
          'time'        : String(new Date()),
          'isSent'      : true,
          'isSeen'      : false,
          'attachment'  :this.files
        }
        }, function(error) {
            if (error) {
              //console.log(error)
            } else {
              //console.log("Saved")
                
            }
              })
            }
            if(role === 'trp'){
              var Ref=firebase.database().ref(u.uid).child(this.activeChatUser.uid).push()
        Ref.set({
           isPinned: this.isChatPinned,
        msg: {
          'role'        : 'post',
          'textContent' : this.typedMessage,
          'time'        : String(new Date()),
          'isSent'      : true,
          'isSeen'      : false,
          'attachment'  :this.files
        }
        }, function(error) {
            if (error) {
              //console.log(error)
            } else {
              //console.log("Saved")
                
            }
              })
            }
          }
          else if(this.$acl.get[0]==='editor'){
            var Ref=firebase.database().ref(u.uid).child(this.activeChatUser.uid).push()
        Ref.set({
           isPinned: this.isChatPinned,
        msg: {
          'role'        : 'editor',
          'textContent' : this.typedMessage,
          'time'        : String(new Date()),
          'isSent'      : true,
          'isSeen'      : false,
          'attachment'  :this.files
        }
        }, function(error) {
            if (error) {
              ////console.log(error)
            } else {
              //console.log("Saved")              
            }
              })

          }
           this.typedMessage = ''
      this.files =''
      this.attachment=''
      this.$refs.chatLogPS.$el.scrollTop = this.$refs.chatLog.scrollHeight
      }
      // this.typedMessage = ''
      // this.files =''
      // this.attachment=''
      // this.$refs.chatLogPS.$el.scrollTop = this.$refs.chatLog.scrollHeight
    },
    toggleIsChatPinned(value) {
      this.isChatPinned = value
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.isChatSidebarActive = this.clickNotClose = false
      } else {
        this.isChatSidebarActive = this.clickNotClose = true
      }
    },
    toggleChatSidebar(value = false) {
      if (!value && this.clickNotClose) return
      this.isChatSidebarActive = value
    }
  },
  components: {
    VuePerfectScrollbar,
    ChatContact,
    UserProfile,
    ChatNavbar,
    ChatLog,
  },
  created() {
    //id-- for id of student
    //idy --- for id of tpo/recruiter
    this.$store.registerModule('chat', moduleChat)
    this.setSidebarWidth()
    this.id = this.$route.query.id
    this.idy = this.$route.query.idy
    const thisIns = this;
    var u= firebase.auth().currentUser
     var role=thisIns.$acl.get[0]
    if(role==='post'){
       firebase.firestore().collection("RecruiterId").doc(u.uid).get().then(doc =>{
         if(doc.exists){
          //  console.log(doc.data())
                        
                        thisIns.arr = doc.data()
                        thisIns.arr.email = u.email
                     if(thisIns.arr.displayName){
                       thisIns.arr.username = thisIns.arr.displayName
                     }
                     if(typeof(thisIns.arr.profilephoto) === undefined){
                       thisIns.arr.photo = ''

                     }
                     else{
                       thisIns.arr.photo = thisIns.arr.profilephoto
                     }
                        thisIns.arr.uid = doc.id
                        //thisIns.chatContacts
                        //thisIns.contacts
         }
       })
      
     }
     if(role ==='hr'){
       firebase.firestore().collection("HRid").doc(u.uid).get().then(doc =>{
         if(doc.exists){
            console.log('hr')
            console.log(doc.data())
                        
                        thisIns.arr = doc.data()
                        thisIns.arr.email = u.email
                     if(thisIns.arr.displayName){
                       thisIns.arr.username = thisIns.arr.ContactName
                     }
                     if(typeof(thisIns.arr.profilephoto) === undefined){
                       thisIns.arr.photo = ''

                     }
                     else{
                       thisIns.arr.photo = thisIns.arr.profilephoto
                     }
                        thisIns.arr.uid = doc.id
                        //thisIns.chatContacts
                        //thisIns.contacts
         }
       })
      
     }

      if(role==='admin'){
      
        //////console.log("Parent Document ID: ", doc.id);
          // const docid =doc.id
         firebase.firestore().collection("TPOid").doc(u.uid).get().then(doc=>{
                   if(doc.exists){
                     thisIns.arr = doc.data()
                     if(typeof(thisIns.arr.photo) === undefined){
                       thisIns.arr.photo = ''

                     }
                        thisIns.arr.uid = doc.id
                        thisIns.collegecode = doc.data().CollegeCode
                        thisIns.studentcode = doc.data().StudentCode
                        //console.log(thisIns.arr)
                 
                     //console.log(thisIns.studentcode)
                     
                   
                   }
                   
                 }).then(()=>{
                   thisIns.contacts
                     thisIns.chatContacts
                 })
      
    
      
     }

     if(role==='trp'){
      
        //////console.log("Parent Document ID: ", doc.id);
          // const docid =doc.id
         firebase.firestore().collection("TRPid").doc(u.uid).get().then(doc=>{
                   if(doc.exists){
                     thisIns.arr = doc.data()
                     if(typeof(thisIns.arr.photo) === undefined){
                       thisIns.arr.photo = ''

                     }
                        thisIns.arr.uid = doc.id
                        thisIns.TRPcode = doc.data().TRPcode
                        thisIns.TRPscode = doc.data().TRPscode
                        //console.log(thisIns.arr)
                 
                     //console.log(thisIns.studentcode)
                     
                   
                   }
                   
                 }).then(()=>{
                   thisIns.contacts
                     thisIns.chatContacts
                 })
      
    
      
     }
     if(role==='editor'){
       
        //////console.log("Parent Document ID: ", doc.id);
        
        let Docs = firebase.firestore().collection("StudentID")
                 Docs.doc(u.uid).get().then(doc=>{
                   if(doc.exists){
                    //  console.log(doc.data())
                     thisIns.arr = doc.data()
                     thisIns.arr.email = u.email
                     if(thisIns.arr.FullName){
                       thisIns.arr.username = thisIns.arr.FullName
                     }
                     if(typeof(thisIns.arr.profilephoto) === undefined){
                       thisIns.arr.photo = ''

                     }
                     else{
                       thisIns.arr.photo = thisIns.arr.profilephoto
                     }
                        thisIns.arr.uid = doc.id
                        if(typeof(doc.data().StudentCode)==='undefined')
                        thisIns.studentcode = doc.data().TRPscode
                        else
                        thisIns.studentcode = doc.data().StudentCode

                        firebase.firestore().collection("CollegeCode").where("StudentCode" , '==', this.studentcode ).onSnapshot(function(snapshot){
                        snapshot.forEach(docs =>{
                          //console.log(docs.data())
                        thisIns.collegecode = docs.data().CollegeCode

                        thisIns.chatContacts

                        })
                        })
                   }
                 })
      
      
     }

  },
  beforeDestroy: function() {
    this.$store.unregisterModule('chat')
  },
  mounted() {
    this.$store.dispatch("chat/setChatSearchQuery", "")
  }
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/chat.scss";
</style>
